import Modal, { ModalProps } from '@/components/Modal';

import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';
import { ShowingTagDto } from '@cineamo/api/models/showing-tag/ShowingTagDto.types';

import { CachedContentData } from '@/hooks/useCachedContentData';

import { usePathname } from '@/i18n/routing';
import { useCinemaRooms } from '@/providers/CinemaRoomProvider';

import BuyTicketButton from './BuyTicketButton';
import ShareShowingLinkButton from './ShareShowingLinkButton';
import ShowingInfoModalContent from './ShowingInfoModalContent';
import ShowingInfoModalTitle from './ShowingInfoModalTitle';

type ShowingInfoModalProps = Omit<ModalProps, 'domainConfiguration'> & {
    showing: ShowingDto;
    content: CachedContentData | undefined;
    specials: (ShowingTagDto | null)[];
    onSubmit: () => void;
    onShare: () => void;
};

export function ShowingInfoModal(props: ShowingInfoModalProps) {
    const { showing, specials, content } = props;
    const isOnContentDetailPage = usePathname() === '/program/[contentId]';
    const { getCinemaRoomById } = useCinemaRooms();
    const cinemaRoom = getCinemaRoomById(showing.cinemaRoomId);

    return (
        <Modal
            {...props}
            onClose={props.onClose}
            title={
                <ShowingInfoModalTitle
                    showing={showing}
                    content={content}
                    isOnContentDetailPage={isOnContentDetailPage}
                />
            }>
            <div className="flex flex-col h-full grow space-y-16">
                <ShowingInfoModalContent
                    showing={showing}
                    cinemaRoom={cinemaRoom}
                    specials={specials}
                    content={content}
                />

                <div className="grow"></div>
                <div className="flex flex-col">
                    <ShareShowingLinkButton
                        showing={showing}
                        onShare={props.onShare}
                        movieId={content?.movieId}
                    />
                    <BuyTicketButton
                        onBuy={props.onSubmit}
                        showing={showing}
                        movieId={content?.movieId}
                    />
                </div>
            </div>
        </Modal>
    );
}
